import DualChoiceModal from './DualChoiceModal'

export default DualChoiceModal
